module.exports = __webpack_public_path__ + "img/francis-goeltner-thesiege-scene03-insidetown.bff6ec66.jpg";